import React, { useState, useRef, useEffect } from 'react';
import ChangePasswordModal from './ChangePasswordModal';
import FeedbackModal from './FeedbackModal';
import './AvatarDropdown.css';

export default function AvatarDropdown({ displayName, onLogout, onOpenChange }) {
  const [open, setOpen] = useState(false);
  const [passwortModal, setPasswortModal] = useState(false);
  const [feedbackOpen, setFeedbackOpen] = useState(false);
  const ref = useRef(null);
  const initial = (displayName || '?')[0].toUpperCase();

  // Der Header muss wissen, ob ein Menü offen ist — ein offenes Menü darf beim
  // Scrollen nicht mit dem Header davonfliegen.
  useEffect(() => {
    onOpenChange?.(open);
  }, [open, onOpenChange]);

  useEffect(() => {
    const handleClickOutside = (e) => {
      if (ref.current && !ref.current.contains(e.target)) setOpen(false);
    };
    // Capture-Phase: Knöpfe, die den Druck anhalten (Umdreh-Knopf von CardImage), schließen
    // das Menü sonst nicht.
    document.addEventListener('mousedown', handleClickOutside, { capture: true });
    return () => document.removeEventListener('mousedown', handleClickOutside, { capture: true });
  }, []);

  return (
    <div className="avatar-dropdown" ref={ref}>
      <button
        className="avatar-dropdown__trigger"
        onClick={() => setOpen((v) => !v)}
        aria-label="Benutzermenu"
        aria-expanded={open}
      >
        {initial}
      </button>
      {open && (
        <div className="avatar-dropdown__panel">
          <div className="avatar-dropdown__user">{displayName}</div>
          <button
            className="avatar-dropdown__action"
            onClick={() => { setPasswortModal(true); setOpen(false); }}
          >
            Passwort ändern
          </button>
          <button
            type="button"
            className="avatar-dropdown__action"
            onClick={() => { setFeedbackOpen(true); setOpen(false); }}
          >
            Feedback geben
          </button>
          <button className="avatar-dropdown__logout" onClick={onLogout}>
            Abmelden
          </button>
        </div>
      )}
      <ChangePasswordModal open={passwortModal} onOpenChange={setPasswortModal} />
      <FeedbackModal open={feedbackOpen} onClose={() => setFeedbackOpen(false)} />
    </div>
  );
}
